import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './Styles/Responsive.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import router from './routes';
import { RouterProvider } from 'react-router-dom';
import store from "./Stores/store";
import {Provider} from 'react-redux';
import { UserProvider } from './context/UserContext';
import { CartProvider } from './context/CartContext';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
    <Provider store={store}>
       <UserProvider>
        <CartProvider >
          <RouterProvider router={router}/>
        </CartProvider>
      </UserProvider>
    </Provider>
  //</React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
